export interface BasePcList {
  id: string; // 标识 id
  name: string; // 路由 name
  path: string; // 路由 path
  link?: string; // 只需 pc
  pcLink?: string; // 需要多个下载 pc
  azLink?: string; // 需要多个下载 az
  iosLink?: string; // 需要多个下载 ios
  sendAplus?: boolean; // 需要发送(window as any).aplus_queue
  isRequest?: boolean; // 需要下载上报接口
}

export const basePcList: BasePcList[] = [
  {
    id: "1",
    name: "360",
    path: "/360",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/996boxSetup@6032.exe",
    azLink: '/static/img/baseImg/download/360_download_android.png',
    iosLink: '/static/img/baseImg/download/base_download_ios.png',
    sendAplus: true,
  },
  {
    id: "2",
    name: "wb",
    path: "/wb",
    pcLink: "//static.dhsf.xqhuyu.com/temporary_file/1657778073000_wHhFp.exe",
    azLink: '/static/img/baseImg/download/wb_download_android.png',
    iosLink: '/static/img/baseImg/download/base_download_ios.png',
  },
  {
    id: "4",
    name: "sougou",
    path: "/sougou",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/996boxSetup@6014.exe",
    azLink: '/static/img/baseImg/download/sougou_download_android.png',
    iosLink: '/static/img/baseImg/download/sougou_download_android.png',
  },
  {
    id: "5",
    name: "3601",
    path: "/3601",
    pcLink: "//static.dhsf.xqhuyu.com/temporary_file/1658812705000_3S6S5.exe",
    azLink: '/static/img/baseImg/download/3601_download_android.png',
    iosLink: '/static/img/baseImg/download/base_download_ios.png',
  },
  {
    id: "6",
    name: "2345",
    path: "/2345",
    link: "//static.dhsf.xqhuyu.com/box/channel_app/996boxSetup@6029.exe",
  },
  {
    id: "7",
    name: "tieba",
    path: "/tieba",
    link: "//static.dhsf.xqhuyu.com/temporary_file/1661243152000_i3s4G.exe",
  },
  {
    id: "8",
    name: "xunyou",
    path: "/xunyou",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/1661762599000_ek2kX.exe",
    azLink: '/static/img/baseImg/download/xunyou_download_android.png',
  },
  {
    id: "9",
    name: "07073",
    path: "/07073",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/996boxSetup@6035.exe",
    azLink: '/static/img/baseImg/download/07073_download_android.png',
  },
  {
    id: "10",
    name: "yueke",
    path: "/yueke",
    link: "//static.dhsf.xqhuyu.com/box/channel_app/1661763691000_jrxZs.exe",
  },
  {
    id: "11",
    name: "yx360",
    path: "/yx360",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/1662456167000_y7Hsm.exe",
    azLink: '/static/img/baseImg/download/yx360_download_android.png',
  },
  {
    id: "12",
    name: "yx3602",
    path: "/yx3602",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/1664271410000_jNNMH.exe",
    azLink: '/static/img/baseImg/download/yx3602_download_android.png',
  },
  {
    id: "13",
    name: "sw360",
    path: "/sw360",
    link: "//static.dhsf.xqhuyu.com/box/channel_app/1666149756000_8KTdK.exe",
  },
  {
    id: "14",
    name: "xunlan",
    path: "/xunlan",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/996box@6043.exe",
    azLink: '/static/img/baseImg/download/xunlan_download_android.png',
  },
  {
    id: "15",
    name: "yueke1",
    path: "/yueke1",
    link: "//static.dhsf.xqhuyu.com/box/channel_app/996box@6044.exe",
    isRequest: true,
  },
  {
    id: "16",
    name: "fs3603",
    path: "/fs3603",
    pcLink: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6051.exe",
    azLink: '/static/img/baseImg/download/fs3603_download_android.png',
    isRequest: true,
  },
  {
    id: "17",
    name: "cnxh",
    path: "/cnxh",
    link: "//static.dhsf.996box.com/box/channel_app/996Setupbox@6064.exe",
  },
  {
    id: "18",
    name: "baidu6",
    path: "/baidu6",
    link: "//static.dhsf.996box.com/box/channel_app/996Setupbox@6067.exe",
  },
  {
    id: "19",
    name: "baidu7",
    path: "/baidu7",
    link: "//static.dhsf.996box.com/box/channel_app/996Setupbox@6068.exe",
  },
];
